module.exports = __webpack_public_path__ + "static/images/megaphone-green.d14000e0931f4ba2107062238ba4ea1f.svg";